import { useQuery } from "react-query";
import useNetworkHealth from "./useNetworkHealth";
import { getLocalData, storeLocalData } from "../services/storage";
import openhouseAPI from "../services/openhouse";

export const useGetTags = () => {
  const network = useNetworkHealth();
  const { isLoading, isFetched, isFetching, data, error, refetch } = useQuery(
    ["getTags", network.isOffline ? null : network.latencyMs],
    async () => {
      if (network.isOffline) {
        const cachedData = await getLocalData(`@filters`);
        if (cachedData) {
          return cachedData;
        }
      } else {
        const { data } = await openhouseAPI.get("/tag/filterTags", {});
        await storeLocalData(`@filters`, data);
        return data;
      }
    },
    {
      enabled: true,
      staleTime: 3000,
      cacheTime: 3000,
    }
  );
  return {
    isLoading,
    isFetched,
    isFetching,
    data,
    error,
    refetch,
  };
};
